// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NoContent_wrapper__yk6gT","container":"NoContent_container__OggIZ"};